import { Languages } from "lucide-react";

import { useLocale } from "@/i18n/locale";
import { ui } from "@/i18n/ui";
import { LOCALE_LABELS } from "@/i18n/types";
import { trackEvent } from "@/lib/analytics";

export function LocaleToggle() {
  const { locale, toggleLocale, t } = useLocale();

  // Worth measuring: how many visitors actually switch, and in which direction.
  // No-ops when analytics did not load.
  const handleClick = () => {
    trackEvent("language_switch", { from: locale, to: locale === "en" ? "pt" : "en" });
    toggleLocale();
  };

  // The button shows the CURRENT language, so the accessible name has to say
  // what pressing it does — phrased in the language being switched TO, which is
  // the one a reader who needs it will understand.
  const action = locale === "en" ? ui.switchToPortuguese.pt : ui.switchToEnglish.en;

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={`${t(ui.languageLabel)}: ${LOCALE_LABELS[locale]}. ${action}.`}
      title={action}
      className="inline-flex h-9 items-center gap-1.5 rounded-sm border border-border bg-surface px-2.5 font-mono text-xs text-muted transition-colors hover:border-border-strong hover:text-text"
    >
      <Languages aria-hidden="true" className="size-4" />
      {LOCALE_LABELS[locale]}
    </button>
  );
}
